import * as React from "react";
import "./project-new.css";
import { Grid, GridColumn, GridRow, Input } from "semantic-ui-react";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import MyDatePicker from "../../../components/date-picker/date-picker";
import { Contact } from "../../../stores/contact/contact-store";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { LandfillSiteProject, LandUsePlanChangeProject, RecultivationProject } from "../../../stores/project/project";

export default function LandfillSiteNew({
                                            municipalities,
                                            contacts,
                                            keyValueStore
                                        }: {
    municipalities: Municipality[];
    contacts: Contact[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridRow>
                    <GridColumn largeScreen={16} widescreen={8}>
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "municipalityName")}
                            desc={getDesc(LandfillSiteProject.prototype, "municipalityName")}
                            inputElement={
                                <select name="municipality" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {municipalities.map((m) => (
                                        <option
                                            key={m.bfsNr}
                                            value={m.bfsNr}
                                        >
                                            {m.name}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "place")}
                            desc={getDesc(LandfillSiteProject.prototype, "place")}
                            inputElement={<Input type="text" name="place"/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "landfillSiteType")}
                            desc={getDesc(LandfillSiteProject.prototype, "landfillSiteType")}
                            inputElement={
                                <select name="landfillSiteType" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.landfillSiteTypes.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "status")}
                            desc={getDesc(LandfillSiteProject.prototype, "status")}
                            inputElement={
                                <select name="status" className="ui selection dropdown">
                                    <option disabled selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.projectStatuses.map((s) => (
                                        <option
                                            key={s.key}
                                            value={s.key}
                                        >
                                            {s.value}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "governmentCouncilDecisionNr")}
                            desc={getDesc(LandfillSiteProject.prototype, "governmentCouncilDecisionNr")}
                            inputElement={<Input type="text" name="governmentCouncilDecisionNr"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "ebageNr")}
                            desc={getDesc(LandfillSiteProject.prototype, "ebageNr")}
                            inputElement={<Input type="text" name="ebageNr"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "enactmentDateDisplayText")}
                            desc={getDesc(LandfillSiteProject.prototype, "enactmentDateDisplayText")}
                            inputElement={<MyDatePicker name="enactmentDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "constructionPermitDateDisplayText")}
                            desc={getDesc(LandfillSiteProject.prototype, "constructionPermitDateDisplayText")}
                            inputElement={<MyDatePicker name="constructionPermitDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "approvedCreationArea")}
                            desc={getDesc(RecultivationProject.prototype, "approvedCreationArea")}
                            inputElement={<Input type="number" name="approvedCreationArea"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "creationGoalSource")}
                            inputElement={
                                <select name="creationGoalSource" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>

                                    {keyValueStore.creationGoalSources.map(e => (
                                        <option key={e.key} value={e.key}>
                                            {e.value}
                                        </option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "cmiDocumentsRawiPre")}
                            desc={getDesc(LandfillSiteProject.prototype, "cmiDocumentsRawiPre")}
                            inputElement={<Input type="text" name="cmiNrRawiPre"/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "cmiDocumentsUwePre")}
                            desc={getDesc(LandfillSiteProject.prototype, "cmiDocumentsUwePre")}
                            inputElement={<Input type="text" name="cmiNrUwePre"/>}
                        />
                    </GridColumn>
                    <GridColumn>
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "cmiDocumentsRawiApproved")}
                            desc={getDesc(LandfillSiteProject.prototype, "cmiDocumentsRawiApproved")}
                            inputElement={<Input type="text" name="cmiNrRawiApproved"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "cmiDocumentsUweApproved")}
                            desc={getDesc(LandfillSiteProject.prototype, "cmiDocumentsUweApproved")}
                            inputElement={<Input type="text" name="cmiNrUweApproved"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "geometrySource")}
                            desc={getDesc(LandfillSiteProject.prototype, "geometrySource")}
                            inputElement={<Input type="text" maxLength={50} name="geometrySource"/>}
                        />
                        <LabeledInput
                            label={getLabel(LandfillSiteProject.prototype, "geometrySourceDateDisplayText")}
                            desc={getDesc(LandfillSiteProject.prototype, "geometrySourceDateDisplayText")}
                            inputElement={<MyDatePicker name="geometrySourceDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "approvedRecultivationArea")}
                            desc={getDesc(RecultivationProject.prototype, "approvedRecultivationArea")}
                            inputElement={<Input type="number" name="approvedRecultivationArea"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "constructionSupervisorFullName")}
                            desc={getDesc(RecultivationProject.prototype, "constructionSupervisorFullName")}
                            inputElement={
                                <select name="constructionSupervisorId" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>
                                    {contacts.map(c => (
                                        <option
                                            key={c.id}
                                            value={c.id}
                                        >{`${c.firstName} ${c.lastName}`}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "operatingPermitDateDisplayText")}
                            desc={getDesc(RecultivationProject.prototype, "operatingPermitDateDisplayText")}
                            inputElement={<MyDatePicker name="operatingPermitDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "maintenanceDirectiveDateDisplayText")}
                            desc={getDesc(RecultivationProject.prototype, "maintenanceDirectiveDateDisplayText")}
                            inputElement={<MyDatePicker name="maintenanceDirectiveDate"/>}
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "requirementsSpecificationBBBStatus")}
                            desc={getDesc(RecultivationProject.prototype, "requirementsSpecificationBBBStatus")}
                            inputElement={
                                <select name="requirementsSpecificationBBBStatus" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlStatuses.map(e => (
                                        <option key={e.key} value={e.key}>
                                            {e.value}
                                        </option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "requirementsSpecificationRequestSource")}
                            desc={getDesc(RecultivationProject.prototype, "requirementsSpecificationRequestSource")}
                            inputElement={
                                <select name="requirementsSpecificationRequestSource" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlSources.map(e => (
                                        <option key={e.key} value={e.key}>
                                            {e.value}
                                        </option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "startConstructionMeetingStatus")}
                            desc={getDesc(RecultivationProject.prototype, "startConstructionMeetingStatus")}
                            inputElement={
                                <select name="startConstructionMeetingStatus" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlStatuses.map(e => (
                                        <option key={e.key} value={e.key}>
                                            {e.value}
                                        </option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(RecultivationProject.prototype, "startConstructionMeetingSource")}
                            desc={getDesc(RecultivationProject.prototype, "startConstructionMeetingSource")}
                            inputElement={
                                <select name="startConstructionMeetingSource" className="ui selection dropdown">
                                    <option key={-1} value="" selected>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlSources.map(e => (
                                        <option key={e.key} value={e.key}>
                                            {e.value}
                                        </option>
                                    ))}
                                </select>
                            }
                        />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn largeScreen={16} widescreen={8}>
                        <LabeledTextArea label={getLabel(LandUsePlanChangeProject.prototype, "remarks")}
                                         name="remarks"/>
                        <LabeledTextArea label={getLabel(RecultivationProject.prototype, "enactmentRemarks")}
                                         name="enactmentRemarks"/>
                        <LabeledTextArea label={getLabel(RecultivationProject.prototype, "creationGoalRemarks")}
                                         name="creationGoalRemarks"/>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    );
}
